import StoreBuilder from '../store-builder';
import { BanniereApi } from '@/api/banniere';
import { Banniere } from '@/model/banniere';

const builder = new StoreBuilder('banniere');

builder.addStatePart('bannieres', []);

builder.setActions({
  fetchBannieres ({ commit }: any) {
    return BanniereApi.getAllBannieres().then((bannieres: Banniere[]) => {
      commit('SET_BANNIERES', bannieres);
    });
  }
});

export default builder.build();
